import React, { PureComponent } from "react";
import classnames from "classnames";

import styles from "./CollaboratorSpace.local.scss";

class CollaboratorSpaceAsideFetching extends PureComponent {
  //******************   Content Functions  **************//
  render() {
    let activitiesFetching = [];
    for (let i = 0; i < 3; i++) {
      activitiesFetching.push(
        <div className={styles.cellule} key={i}>
          <div className={styles.cellule_header}>
            <div className={classnames(styles.icone_frame, styles.gradiant)} />
            <span className={styles.gradiant} />
          </div>
          <div className={classnames(styles.title, styles.gradiant)} />
          <div className={classnames(styles.title, styles.gradiant)} />
        </div>
      );
    }
    return <div className={styles.fetching_cellules}>{activitiesFetching}</div>;
  }
}

export default CollaboratorSpaceAsideFetching;



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CollaboratorSpaceAsideFetching.js